import React, { useEffect, useState } from 'react'
import style from './cardListEmployees.module.scss'
import CardEmployeeSmall from '../CardEmployeeSmall/CardEmployeeSmall'
import { useAppSelector } from '../../starter/hooks/redux'
import { useDrop } from 'react-dnd'
import { IEmployee, IProjectToEmployeeLink } from '../../starter/model/interfaces'
import { Button, Input } from 'antd'
import CreatePeriod from '../CreatePeriod/CreatePeriod'
import { useActions } from '../../starter/hooks/actions'
import { store } from '../../starter/redux/store'
import {
  useDeleteProjectEmployeeLinkMutation,
  useUpdateProjectEmployeeLinksMutation
} from '../../starter/api/projectEmployeeLinksApi'
import { DeleteOutlined } from '@ant-design/icons'
import dayjs from 'dayjs'

const CardListEmployees = () => {
  const { employees } = useAppSelector((state) => state.employees)
  const modalData = useAppSelector((state) => state.modal)
  const [freeEmployees, setFreeEmployee] = useState<IEmployee[]>([])
  const { projectEmployeeLinks } = useAppSelector((state) => state.projectEmployeeLinks)
  const { setButtonSet, onShowModal, setModalData, setTmpPeriod } = useActions()
  const [updateLink, { isLoading: isLoadingUpdateLink, isSuccess: isSuccessUpdateLink }] =
    useUpdateProjectEmployeeLinksMutation()
  const [dropLink, { isLoading: isLoadingDropLink, isSuccess: isSuccessDropLink }] =
    useDeleteProjectEmployeeLinkMutation()

  const [filter, setFilter] = useState<string>('')

  useEffect(() => {
    if (isSuccessUpdateLink || isSuccessDropLink) {
      onShowModal(false)
    }
  }, [isSuccessUpdateLink, isSuccessDropLink])

  // ищем не занятых сотрудников
  useEffect(() => {
    const allPeriodsEmployee = employees.reduce((result: any, current) => {
      result[current._id] = []
      return result
    }, {})
    projectEmployeeLinks.forEach((link) => {
      if (allPeriodsEmployee[link.employee._id]) {
        allPeriodsEmployee[link.employee._id].push(...link.periods.filter((f) => !f.isHidden))
      }
    })

    const _freeEmployees: IEmployee[] = []
    Object.keys(allPeriodsEmployee).forEach((key) => {
      // @ts-ignore
      const actual = allPeriodsEmployee[key].find((p) => dayjs(p.startTime) <= dayjs() && dayjs() <= dayjs(p.endTime))
      if (!actual) {
        // @ts-ignore
        _freeEmployees.push(employees.find((e) => e._id === key))
      }
    })
    setFreeEmployee(_freeEmployees)
  }, [employees, projectEmployeeLinks])

  useEffect(() => {
    const _buttonSet = modalData.buttonSet.map((button) => ({
      ...button,
      loading: isLoadingUpdateLink || isLoadingDropLink
    }))

    setModalData({
      buttonSet: _buttonSet,
      footer: _buttonSet.map((item, index) => <Button key={index} {...item} />)
    })
  }, [isLoadingUpdateLink, isLoadingDropLink])

  const [{ isActive, canDrop }, dropRef] = useDrop({
    accept: 'employee',
    drop(item: IProjectToEmployeeLink, monitor) {
      let isSetHidden = false
      let _periods = item.periods.map((period) => {
        if (!period.isHidden && dayjs(period.endTime) < dayjs()) {
          isSetHidden = true
          return {
            ...period,
            isHidden: true
          }
        } else {
          return period
        }
      })

      if (isSetHidden) {
        updateLink({ ...item, periods: _periods })
      } else {
        onShowModal(true)
        setButtonSet([
          {
            type: 'primary',
            onClick: () => removeLink(item),
            children: 'Ok'
          },
          {
            onClick: () => onShowModal(false),
            children: 'Cancel'
          }
        ])
        setModalData({
          title: 'выберите удаляемые периоды',
          content: <CreatePeriod onChange={setTmpPeriod} periods={item ? item.periods : []} showRange={false} />
        })
      }
    },
    collect: (monitor) => ({
      isActive: monitor.isOver(),
      canDrop: monitor.canDrop()
    })
  })

  const removeLink = (linkItem: IProjectToEmployeeLink) => {
    const { selectedPeriods: selectedTmpPeriods } = { ...store.getState()?.tmp }
    const _linkItem: IProjectToEmployeeLink = {
      ...linkItem,
      periods:
        linkItem && selectedTmpPeriods
          ? linkItem.periods.filter((period) => !selectedTmpPeriods.map((item) => item.id).includes(period.id)) || []
          : linkItem.periods
    }

    if (_linkItem.periods.length === 0) {
      dropLink(linkItem)
    } else {
      updateLink(_linkItem)
    }
  }

  const filterPattern = (item: IEmployee) => {
    return !filter || `${item.firstName} ${item.lastName}`.toLowerCase().includes(filter.toLowerCase())
  }

  return (
    <div className={style.wrapper} ref={dropRef}>
      {(isActive || canDrop) && (
        <div className={style.remove}>
          <DeleteOutlined className={style.removeIcon} />
        </div>
      )}
      <Input
        value={filter}
        onChange={(e) => {
          setFilter(e.target.value)
        }}
      />
      <div className={style.list}>
        {employees &&
          employees
            .filter(filterPattern)
            .map((employee) => (
              <CardEmployeeSmall
                key={employee._id}
                employee={employee}
                isFree={freeEmployees.map((e) => e._id).includes(employee._id)}
              />
            ))}
      </div>
    </div>
  )
}

export default CardListEmployees
